export default "__VITE_ASSET__CNtbI0SB__"